const teamQuestionsMockData = {
    questions: [
        {
            questionId: "team_process_question",
            questionHeader: "Is our review process running well?",
        },
        {
            questionId: "team_time_spending_question",
            questionHeader: "Are we spending our time on the right things?",
        },
        {
            questionId: "team_sustainability_question",
            questionHeader: "Are our engineers working sustainably?",
        },
        {
            questionId: "team_code_quality_question",
            questionHeader:
                "Does our planning, process, and pipeline infrastructure allow us to produce high quality code?",
        },
        {
            questionId: "team_goals",
            questionHeader: "Are we achieving our goals?",
        },
    ],
};

export default teamQuestionsMockData;
